import { Navigate } from 'react-router-dom'
import { AppRoutes } from '../../axios/endPoints'
import { RootState, useAppSelector } from '../../store/store'
import { Roles } from '../layout/menu-items'

export function AuthPageRouting({ children }: { children: React.ReactElement }) {
    const { token, user } = useAppSelector((state: RootState) => state.auth)

    if (!token) {
        return children
    }

    const target = user.role === Roles.MLViewer ? AppRoutes.ML_PREDICTION : AppRoutes.ML_CREATOR
    return <Navigate to={target} replace />
}
